module.exports = __webpack_public_path__ + "img/footer_gaming1.712b9f57.png";